<div class="select_lang ml-auto d-inline-block right-0 top-0 language-area responsive-lng pr-2">
  <div class="d-flex align-items-center justify-content-center">
    <a (click)="setLang('en')" [ngClass]="selected == 'en'? 'active-lang' : theme === 'dark' ? 'text-white': 'text-secondary'" class="px-2 cursor-pointer">
      English
    </a>
    <span class="">|</span>
    <a (click)="setLang('es')" [ngClass]="selected == 'es'? 'active-lang': theme === 'dark' ? 'text-white': 'text-secondary'" class="px-2 cursor-pointer">
      Español
    </a>
  </div>
</div>
